import { render, staticRenderFns } from "./FabricProcessCreateEdit.vue?vue&type=template&id=6ad97a66&scoped=true&"
import script from "./FabricProcessCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricProcessCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricProcessCreateEdit.vue?vue&type=style&index=0&id=6ad97a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad97a66",
  null
  
)

export default component.exports